import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';
import { paginatedResponse } from './util-schema-types';
import { filteringSchemaFrom, pagingSchema } from './modifier';

export const announcementPlacementSchema = z.enum(['teacher_my_schedule']);
export type AnnouncementPlacement = z.infer<typeof announcementPlacementSchema>;
export const AnnouncementPlacement = announcementPlacementSchema.enum;
export const AnnouncementPlacementLabelMap: Record<AnnouncementPlacement, string> = {
  teacher_my_schedule: 'Teacher My Schedule',
};

export const announcementTypeSchema = z.enum(['general', 'informative', 'success', 'caution', 'urgent']);
export type AnnouncementType = z.infer<typeof announcementTypeSchema>;
export const AnnouncementType = announcementTypeSchema.enum;
export const AnnouncementTypeLabelMap: Record<AnnouncementType, string> = {
  general: 'General',
  informative: 'Informative',
  success: 'Success',
  caution: 'Caution',
  urgent: 'Urgent',
};

export const announcementStatusSchema = z.enum(['active', 'inactive']);
export type AnnouncementStatus = z.infer<typeof announcementStatusSchema>;
export const AnnouncementStatus = announcementStatusSchema.enum;
export const AnnouncementStatusLabelMap: Record<AnnouncementStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
};

export const announcementSchema = z.object({
  id: z.string(),
  title: z.string().nullable().optional(),
  content: z.string(),
  placement: announcementPlacementSchema,
  type: announcementTypeSchema,
  status: announcementStatusSchema,
  createdAt: z.instanceof(Temporal.Instant),
  updatedAt: z.instanceof(Temporal.Instant),
});
export type Announcement = z.infer<typeof announcementSchema>;

export const updateAnnouncementOptionsSchema = announcementSchema.pick({
  title: true,
  content: true,
  placement: true,
  type: true,
  status: true,
});
export type UpdateAnnouncementOptions = z.infer<typeof updateAnnouncementOptionsSchema>;

export const getAnnouncementsFilterSchema = z.object({
  query: z.string().optional(),
  placements: z.array(announcementPlacementSchema).optional(),
  types: z.array(announcementTypeSchema).optional(),
  statuses: z.array(announcementStatusSchema).optional(),
});
export type GetAnnouncementsFilter = z.infer<typeof getAnnouncementsFilterSchema>;

export const getAnnouncementsModifierSchema = pagingSchema.merge(filteringSchemaFrom(getAnnouncementsFilterSchema));
export type GetAnnouncementsModifier = z.infer<typeof getAnnouncementsModifierSchema>;

export const getAnnouncementsResultsSchema = paginatedResponse.extend({
  announcements: z.array(announcementSchema),
});
export type GetAnnouncementsResults = z.infer<typeof getAnnouncementsResultsSchema>;
